//const Backofficebff: string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CommentCommand: any = {
    PostCommentAssignToMe: `${Backofficebff}/v1/product-comments/assigntome`,
    PostCommentTicketAdd: `${Backofficebff}/v1/product-comments/ticket-list/add`,
    DeleteCommentTicket: `${Backofficebff}/v1/product-comments/ticket-list`,
    PostCommentStatusUpdate: `${Backofficebff}/v1/product-comments/status-update`,
    AssignOperatorReviewSummary: `${Backofficebff}/v1/product-comments/assignoperatorreviewsummary`,
    GetReviewsSummaries: `${Backofficebff}/v1/product-comments/getreviewssummaries`,
    UpdateReviewsSummary: `${Backofficebff}/v1/product-comments/updatereviewssummary`,
    PostCommentAssignToMeV2: `${Backofficebff}/v1/product-comments/assigntome-v2`,
    PostCommentStatusUpdateV2: `${Backofficebff}/v1/product-comments/status-update-v2`,
    CreateRejectPhotoReason: `${Backofficebff}/v1/product-comments/create-photo-reject-reason`,
    UpdateRejectPhotoReason: `${Backofficebff}/v1/product-comments/update-photo-reject-reason`,
    DeleteRejectPhotoReason: `${Backofficebff}/v1/product-comments/delete-photo-reject-reason`,
};
